/**
 * Renders a tab count for the pill: `-` until the count has loaded (or when
 * it failed to). Shared by every manager that shows TabCountPill so the
 * loading/error placeholder can't drift between tab bars.
 *
 * Lives in its own module (not TabCountPill.tsx) so the component file only
 * exports components, keeping Fast Refresh working.
 */
export const formatTabCount = (count: number | null | undefined): string =>
  typeof count === 'number' ? count.toString() : '-';
